<template>
    <vx-box
        :class="{
            'rounded-[16px] border border-solid border-slate-300 bg-slate-200': !open,
        }"
        :color="open ? 'info' : 'white'"
        class="py-4 lg:py-6"
    >
        <div class="flex items-center justify-between text-slate-800 px-4 lg:pl-9 lg:pr-6">
            <div class="flex items-center gap-4">
                <font-awesome-icon widthAuto :icon="faScrewdriverWrench" class="text-base ml-2" />

                <span class="font-extrabold lg:text-xl">Actions</span>
                <vx-badge color="primary" size="xs" data-test="filters-count">
                    {{ data.automated_actions.length }}
                </vx-badge>
            </div>

            <div>
                <vx-button @click="open = !open" class="w-12 px-4 ml-4" color="muted-dark" size="md" type="button">
                    <font-awesome-icon widthAuto :icon="open ? faCaretUp : faCaretDown"></font-awesome-icon>
                </vx-button>
            </div>
        </div>

        <animate-height :height="open ? 'auto' : 0">
            <div class="mt-4 px-4 relative lg:px-6">
                <div class="absolute left-8 top-0 w-px h-full bg-slate-300 lg:left-16"></div>

                <automation-rule-form-action
                    v-for="(action, actionIndex) in data.automated_actions"
                    :key="action.id"
                    v-model="data.automated_actions[actionIndex]"
                    :actionIndex="actionIndex"
                >
                </automation-rule-form-action>

                <div class="flex items-center gap-4">
                    <vx-box class="relative p-3 inline-flex space-x-2">
                        <vx-button @click="addAction()" type="button" size="lg" color="primary" data-test="add-action">
                            Then Do <font-awesome-icon widthAuto :icon="faCirclePlus"></font-awesome-icon>
                        </vx-button>
                    </vx-box>
                </div>
            </div>
        </animate-height>
        <div v-if="props.error" class="relative px-7 pt-4 text-xs text-rose-800">
            {{ props.error }}
        </div>
    </vx-box>
</template>

<script setup>
import { ref } from 'vue';
import { faCaretDown, faCaretUp, faScrewdriverWrench, faCirclePlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxBox, VxButton, VxBadge } from '@voxie/frontend-components';
import AnimateHeight from 'vue-animate-height';
import { useAutomationRule } from './useAutomationRule';
import AutomationRuleFormAction from './AutomationRuleFormAction.vue';

const props = defineProps({
    error: String,
});

const { data, addAction } = useAutomationRule();
const open = ref(true);
</script>
